@if (notifications?.length) {
  <button
    class="notification-button mx-3"
    mat-mini-fab
    [matMenuTriggerFor]="bell"
    >
    <mat-icon
      [matBadge]="notifications.length"
      matBadgeColor="warn"
      class="notification-button__icon"
      aria-hidden="false"
      >notifications_none</mat-icon
      >
    </button>
  }
  <mat-menu #bell="matMenu" xPosition="before" class="notification-menu mt-5">
    @if (notifications?.length) {
      <div>
        @for (n of notifications; track n) {
          <button
            (click)="navigate(n.id)"
            mat-menu-item
            class="notification-menu__button"
            >
            <mat-icon class="notification-icon">notifications_none</mat-icon>
            {{ n.text }}
            </button>
          }
        </div>
      }
    </mat-menu>
